// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__ROHr2","title":"Images90_title__2NF16","images":"Images90_images__1Co0S"};